import React, {useEffect, useState} from "react";
import {useUpdateEffect} from "ahooks";
import {connect} from "dva";

import {component_tool, framework_tool, utils_tool} from "@/tool";

import createColumns from "./surveyListColumns";

const {modelUtils} = framework_tool
const {WizCard, WizCol, WizDataTable, WizListSelect, WizRow, WizSearchBar} = component_tool
const {getPageData} = utils_tool;

const Index = (
  {
    refInstance: ref,
    dispatch,
    surveyLoading,
    surveyListRes,

    selectedRows: _selectedRows,
    exists,
    updateRows,
    handleClear,
  }
) => {
  const [dataItems, setDataItem] = useState(getPageData({}))
  const [selectedRows, setSelectedRows] = useState([])

  const getData = (data = {}) => {
    dispatch({
      type: 'survey/list',
      payload: {
        key: 'survey@list',
        apiParams: {
          typeList: [0, 3],
          status: 1,
          ...data,
        }
      },
    })
  }

  useEffect(() => {
    // 先初始化选择的数据
    if(_selectedRows?.length) setSelectedRows(_selectedRows)
    getData();
  }, [])
  useUpdateEffect(() => {
    const {success, msg, data} = surveyListRes
    if (!success) {
      wizNotice.error(msg);
      return;
    }
    setDataItem(getPageData(data || {}))
  }, [surveyListRes])
  useEffect(() => {
    console.debug('dataItems:', dataItems)
  }, [dataItems]);

  useUpdateEffect(() => {
    updateRows(selectedRows)
  }, [selectedRows])


  const columns = createColumns()


  const searchBarProps = {
    columns,
    collapse: false,
    onSearch: values => getData(values),
  }
  const rowKey = 'id'
  const dataTableProps = {
    loading: surveyLoading,
    columns,
    rowKey: rowKey,
    dataItems,
    selectType: "checkbox",
    showNum: false,
    isScroll: true,
    onChange: ({pageNum, pageSize}) => {
      getData({current: pageNum, size: pageSize});
    },
    selectedRowKeys: selectedRows.map(item => item[rowKey]),
    onSelect: (keys, rows) => {
      setSelectedRows(rows)
    },
    needOnRowSelect: record => !isNeedDisabled(record?.id),
    rowSelection: {
      getCheckboxProps: record => ({
        disabled: isNeedDisabled(record?.id),
      }),
    },

  }

  const listSelectProps = {
    rowKey: rowKey,
    type: '课件',
    rows: selectedRows || [],
    handerClear: (key) => {
      setSelectedRows(selectedRows => selectedRows.filter(item => item[rowKey] !== key))
    }
  }

  const isNeedDisabled = (id) => {
    return !!exists?.find(item => item.type === 2 && item.entityId === id)
  }


  return (
    <WizRow>
      <WizCol span={16}>
        <WizCard bodyStyle={{padding: '0 15px'}}>
          <WizSearchBar
            type="grid"
            {...searchBarProps}
            cols={{xs: 14, md: 12, xl: 10}}
          />
          <WizDataTable style={{marginTop: 15}} {...dataTableProps} />
          <div className="pagination">
            <WizDataTable.Pagination {...dataTableProps} />
          </div>
        </WizCard>
      </WizCol>
      <WizCol span={8}>
        <WizListSelect {...listSelectProps} />
      </WizCol>
    </WizRow>
  )
}

const mapStateToProps = (state, ownProps) => {
  const {survey} = state;
  const surveyList = modelUtils.getModelEntity(survey, "survey@list");

  const load = modelUtils.getLoadingState(state, "survey");
  return {
    surveyListRes: surveyList,
    ...load
  };
};

const Tc = connect(mapStateToProps, null, null, {forwardRef: true})(Index)
export default React.forwardRef((props, ref) => <Tc {...props} refInstance={ref}/>)
